<nav class="mobile-bottom-nav fixed-bottom d-md-none">
  <div class="pill-track">
    <div class="pill-indicator" [style.width]="pillWidth" [style.transform]="'translateX(' + pillOffset + '%)'"></div>
  </div>
  <div class="tab-container">
    <button
      *ngFor="let tab of tabs"
      class="tab-btn"
      [class.active]="activeKey === tab.key"
      (click)="selectTabClick(tab.key)"
      (touchend)="selectTabTouch(tab.key, $event)">
      <span class="tab-icon-wrap">
        <i class="bi" [ngClass]="tab.icon"></i>
        <span class="tab-badge" *ngIf="tab.count != null && tab.count > 0">{{ tab.count }}</span>
      </span>
      <span class="tab-label">{{ tab.label }}</span>
    </button>
  </div>
</nav>

